import React from "react";

// Render the opponent cell - home vs away or could be tennis
const OpponentCell = ({ scheduleItem, isHome }: { scheduleItem: any; isHome: boolean }) => {
  const oppTeamMatchupKey = isHome ? "away" : "home";

  const opponent = scheduleItem[`${oppTeamMatchupKey}Team`] ?? {
    preferredAbbreviation: "--",
  };

  return (
    <span className="schedule-list__table-cell">
      <span className="schedule-list__opp_container">
        {`${isHome ? "vs." : "@"} ${opponent.preferredAbbreviation}`}
      </span>
    </span>
  );
};

export default OpponentCell;
